export default "__VITE_ASSET__DdtpM0wu__"